module.exports = __webpack_public_path__ + "media/images/faces/female/6-23026984e8687d87633e777dafb2291b.jpg";